import { useRef, useState, useEffect } from "react";
import { Navbar } from "../../components/Navbar";
import Footer from "../../components/Footer";
import TypewriterRotatingText from "../../components/Letreiro/TypewriterRotatingText";
import estilo from "./home.module.css";
import minhaFoto from "../../assets/foto.jpeg";
import { motion, useInView, easeInOut, useAnimation } from "framer-motion";
import { toast } from "react-toastify";
import etiqueta from "../../assets/etiqueta.jpeg";
import cine from "../../assets/cine.png";
import somdafe from "../../assets/somdafe.png";
import certificado from "../../assets/certificado.png";
import convite from "../../assets/convite.png";
import Load from "../../components/Load";


const cardData = [
    {
        id: 1,
        title: "Etiquetas Pimaco",
        description: "Crie etiquetas Pimaco de forma fácil e rápida.",
        image: etiqueta,
        link: "https://etiqueta.web.app/"
    },
    {
        id: 2,
        title: "Cine Ofshore",
        description: "Sua Página Moderna para Assistir Filmes.",
        image: cine,
        link: "https://cine-offshore.web.app/"
    },
    {
        id: 3,
        title: "Somdafe",
        description: "Ouça louvores que tocam o coração e fortalecem sua fé.",
        image: somdafe,
        link: "https://somdafe.web.app/"
    },
    {
        id: 4,
        title: "Certificado",
        description: "Permite a consulta dos certificados cadastrados.",
        image: certificado,
        link: "https://seu-certificado.web.app/"
    },
    {
        id: 5,
        title: "Convite Chá de Panela",
        description: "Convite digital interativo.",
        image: convite,
        link: "https://convite-cha-panela.web.app/#/uC52Wl5eawMR26kr2bAWvoKKqrp2"
    },

];

export default function Home() {
    // === Refs das seções === 
    const homeRef = useRef(null);
    const sobreRef = useRef(null);
    const projetosRef = useRef(null);
    const contatosRef = useRef(null);
    const sobreControls = useAnimation();
    const fotoControls = useAnimation();
    const containerRef = useRef(null);
    const [loadGeral, setLoadGeral] = useState(false);
    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [mensagem, setMensagem] = useState("");

    // === Estado da seção ativa no menu ===
    const [activeSection, setActiveSection] = useState("home");

    // === Estado de animação de cada seção ===
    const [animateHome, setAnimateHome] = useState(false);
    const [animateSobre, setAnimateSobre] = useState(false);
    const [animateProjetos, setAnimateProjetos] = useState(false);
    const [animateContatos, setAnimateContatos] = useState(false);

    // === Detecta se cada seção está na viewport ===
    const isInViewHome = useInView(homeRef, { once: false, margin: "-100px" });
    const isInViewSobre = useInView(sobreRef, { once: false, margin: "-100px" });
    const isInViewProjetos = useInView(projetosRef, { once: false, margin: "-100px" });
    const isInViewContatos = useInView(contatosRef, { once: false, margin: "-100px" });

    // === Atualiza animação conforme scroll ===
    useEffect(() => { if (isInViewHome) setAnimateHome(true); else setAnimateHome(false); }, [isInViewHome]);
    //useEffect(() => { if (isInViewSobre) setAnimateSobre(true); else setAnimateSobre(false); }, [isInViewSobre]);
    useEffect(() => { if (isInViewProjetos) setAnimateProjetos(true); else setAnimateProjetos(false); }, [isInViewProjetos]);
    useEffect(() => { if (isInViewContatos) setAnimateContatos(true); else setAnimateContatos(false); }, [isInViewContatos]);

    // === Dispara animação automática quando seção "Sobre" entra na tela ===
    useEffect(() => {
        if (isInViewSobre) {

            sobreControls.start({
                opacity: 1,
                x: 0,
                transition: { type: "spring", stiffness: 80, damping: 20, duration: 1 },
            });

            fotoControls.start({
                opacity: 1,
                x: 0,
                y: [0, -10, 0],
                transition: {
                    x: { type: "spring", stiffness: 80, damping: 20, duration: 1 },
                    opacity: { duration: 0.8 },
                    y: { duration: 3, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" },
                },
            });
        } else {
            // opcional: reseta quando sai da tela
            sobreControls.start({ opacity: 0, x: -300 });
            fotoControls.start({ opacity: 0, x: 300 });

        }
    }, [isInViewSobre]);


    // === Scroll suave e animação via clique ===
    const scrollToSection = async (ref) => {
        ref.current?.scrollIntoView({ behavior: "smooth" });

        if (ref === homeRef) setAnimateHome(true);
        if (ref === projetosRef) {
            setAnimateProjetos(true);
            containerRef.current.scrollTop = 0;   // scroll vertical
            containerRef.current.scrollLeft = 0;  // scroll horizontal
        }
        if (ref === contatosRef) setAnimateContatos(true);

        if (ref === sobreRef) {


            // 🔁 Primeiro reseta o estado
            await sobreControls.start({ opacity: 0, x: -300 });
            await fotoControls.start({ opacity: 0, x: 300 });

            // ✨ Depois dispara a animação normal
            sobreControls.start({
                opacity: 1,
                x: 0,
                transition: { type: "spring", stiffness: 80, damping: 20, duration: 1 },
            });

            fotoControls.start({
                opacity: 1,
                x: 0,
                y: [0, -10, 0],
                transition: {
                    x: { type: "spring", stiffness: 80, damping: 20, duration: 1 },
                    opacity: { duration: 0.8 },
                    y: { duration: 3, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" },
                },
            });
        }
    };


    // === Atualiza o menu ativo automaticamente ===
    useEffect(() => {
        const sections = [
            { ref: homeRef, name: "home" },
            { ref: sobreRef, name: "sobre" },
            { ref: projetosRef, name: "projetos" },
            { ref: contatosRef, name: "contatos" },
        ];

        const handleScroll = () => {
            const scrollPos = window.scrollY + 120; // ajuste para header fixo
            for (let section of sections) {
                if (
                    section.ref.current.offsetTop <= scrollPos &&
                    section.ref.current.offsetTop + section.ref.current.offsetHeight > scrollPos
                ) {
                    setActiveSection(section.name);
                    break;
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // === Função genérica para animar imagens e divs ===
    const getImageAnimate = (animate) => ({
        opacity: animate ? 1 : 0,
        x: animate ? 0 : -100,
        y: animate ? [0, -8, 0] : 0,
    });

    const getDivAnimate = (animate) => ({
        opacity: animate ? 1 : 0,
        x: animate ? 0 : 100,
    });


    //mascara para celular
    const celularMascara = (event) => {
        try {
            if (event === "") {
                return;
            }
            let tres = event.target.value.replace(/\D/g, "");
            var ajuste = tres.substring(2, 3);

            if (ajuste === '9') {
                var celular = event.target.value.replace(/\D/g, "")
                    .replace(/(\d{2})(\d)/, '($1)$2')
                    .replace(/(\d{1})(\d{2})/, '$1 $2')
                    .replace(/(\d{4})(\d)/, '$1-$2')
                    .replace(/(-\d{4})\d+?$/, '$1')
                setCelular(celular);

            } else {
                var celular = event.target.value.replace(/\D/g, "")
                    .replace(/(\d{2})(\d)/, '($1)$2')
                    .replace(/(\d{4})(\d)/, '$1-$2')
                    .replace(/(-\d{4})\d+?$/, '$1')
                setCelular(celular);
            }
        } catch (error) {

        }

    }


    //enviar email
    const EmailPerfil = async () => {
        try {
            if (nome === "") {
                toast.warning(
                    "Preencha seu nome!", { autoClose: 5000 }
                );
                return;
            }
            if (email === "") {
                toast.warning(
                    "Preencha seu e-mail!", { autoClose: 5000 }
                );
                return;
            }
            if (celular === "") {
                toast.warning(
                    "Preencha seu celular!", { autoClose: 5000 }
                );
                return;
            }
            if (mensagem === "") {
                toast.warning(
                    "Preencha a mensagem!", { autoClose: 5000 }
                );
                return;
            }

            setLoadGeral(true);
            await new Promise((r) => setTimeout(r, 500));

            let informacao = {
                receber: "lchtrentin@gmail.com",
                assunto: "Mensagem do perfil",
                texto: `Nome: ${nome}, celular: ${celular}, ${mensagem}`
            }



            const response = await fetch(
                "https://southamerica-east1-apostas-9a801.cloudfunctions.net/api/emailperfil",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        receber: informacao.receber,
                        assunto: informacao.assunto,
                        texto: informacao.texto,
                    }),
                }
            );

            if (response.ok) {
                //  const result = await response.text();
                //  console.log("Sucesso:", result);
                setNome("");
                setEmail("");
                setCelular("");
                setMensagem("");
                setLoadGeral(false);
                toast.success(
                    "Mensagem enviada com sucesso!", { autoClose: 5000 }
                );
            } else {
                setLoadGeral(false);
                toast.error("Erro no envio:", response.statusText);
            }
        } catch (error) {
            toast.error("Erro:", error);
        }
    };


    return (
        <>

            {loadGeral && <Load titulo={"Aguarde..."} />}

            <Navbar
                onLinkClick={(section) => {
                    if (section === "home") scrollToSection(homeRef);
                    if (section === "sobre") scrollToSection(sobreRef);
                    if (section === "projetos") scrollToSection(projetosRef);
                    if (section === "contatos") scrollToSection(contatosRef);
                }}
                activeSection={activeSection}
            />

            {/* === HOME === */}
            <section ref={homeRef}
                className={estilo.pagHome}
            >
                <div className={estilo.home}>
                    <div className={estilo.foto}>
                        <motion.img
                            src={minhaFoto}
                            alt="luis"
                            className={estilo.minhafoto}
                            initial={{ opacity: 0, x: -200 }}
                            animate={getImageAnimate(animateHome)}
                            transition={{
                                x: { duration: 0.8, ease: "easeOut" },
                                opacity: { duration: 0.8 },
                                y: { duration: 5, ease: "easeInOut", repeat: animateHome ? Infinity : 0 },
                            }}
                        />
                    </div>

                    <motion.div
                        initial={{ opacity: 0, x: 300 }}
                        animate={getDivAnimate(animateHome)}
                        transition={{ duration: 1, ease: easeInOut, delay: 0.3 }}
                        className={estilo.apresenta}
                    >
                        <span className={estilo.ola}>Olá, me chamo</span>
                        <span className={estilo.nome}>Luis Carlos</span>
                        <TypewriterRotatingText />
                        <span className={estilo.descricao}>
                            Desenvolvedor Fullstack apaixonado por criar experiências digitais incríveis.
                            Com habilidades em HTML, CSS e JavaScript, transformo ideias em interfaces
                            intuitivas e responsivas. Sempre em busca de inovação e aprimoramento contínuo.
                        </span>
                    </motion.div>
                </div>
            </section>

            {/* === SOBRE === */}
            <section ref={sobreRef} className={estilo.pagSobre}>
                <div className={estilo.sobre}>
                    {/* ===== Texto ===== */}
                    <motion.div
                        className={estilo.apresentaSobre}
                        initial={{ opacity: 0, x: -300 }}
                        animate={sobreControls} // controle direto
                    >
                        <h2 className={estilo.sobreTitulo}>Sobre mim</h2>
                        <p className={estilo.sobreDev}>
                            <span className={estilo.text_red}>Eu sou um</span>{" "}
                            <span className={estilo.text_blue}>Dev..</span>
                        </p>
                        <p className={estilo.descricaoSobre}>
                            Como Desenvolvedor Fullstack, busco transformar ideias em experiências digitais envolventes.
                            Utilizando HTML, CSS, JavaScript, React, Node.js e Firebase, crio interfaces interativas, responsivas e funcionais, com back-end eficiente.
                            Sempre motivado por inovação e evolução contínua, entregando soluções criativas e integradas.
                        </p>
                    </motion.div>

                    {/* ===== Foto ===== */}
                    <div className={estilo.fotoSobre}>
                        <motion.img
                            src={minhaFoto}
                            alt="luis"
                            className={estilo.minhafotoSobre}
                            initial={{ opacity: 0, x: -200 }}
                            animate={fotoControls} // controle direto
                        />
                    </div>
                </div>
            </section>



            {/* === PROJETOS === */}

            <section ref={projetosRef} style={{ padding: "2rem 2rem" }}
                className={estilo.pagProjeto}
            >
                <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    animate={isInViewProjetos ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
                    transition={{ duration: 1 }}
                    className={estilo.projeto}
                >
                    <span className={estilo.projetoTexto}>Projetos</span>
                </motion.div>

                <div className={estilo.cardsContainer} ref={containerRef} id="cardsContainer">
                    {cardData.map((card, index) => {
                        const fromLeft = index % 2 === 0;
                        return (
                            <motion.a
                                key={card.id}
                                href={card.link}
                                target="_blank"
                                className={estilo.card}
                                initial={{ opacity: 0, x: fromLeft ? -100 : 100 }}
                                animate={isInViewProjetos ? { opacity: 1, x: 0, y: [0, -5, 0] } : { opacity: 0, x: fromLeft ? -100 : 100, y: 0 }}
                                transition={{
                                    duration: 0.8,
                                    delay: index * 0.2,
                                    ease: "easeOut",
                                    y: { duration: 3, repeat: isInViewProjetos ? Infinity : 0, ease: "easeInOut" },
                                }}
                                whileHover={{ scale: 1.05, boxShadow: "0 10px 20px rgba(0,0,0,0.2)" }}
                            >
                                <img src={card.image} alt={card.title} className={estilo.cardImg} />
                                <span>{card.title}</span>
                                <p>{card.description}</p>
                            </motion.a>
                        );
                    })}
                </div>
            </section>



            {/* === CONTATOS === */}
            <section ref={contatosRef} style={{ paddingTop: 20 }}>
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={animateContatos ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                    transition={{ duration: 1 }}
                    className={estilo.contato}
                >
                    <span className={estilo.contatoTexto}>Contate-me</span>


                    <div className={estilo.contatoLista}>
                        {/* Nome */}
                        <input
                            type="text"
                            placeholder="Nome completo"
                            className={estilo.contatoInput}
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />

                        {/* Email */}
                        <input
                            type="email"
                            placeholder="Seu e-mail"
                            className={estilo.contatoInput}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                        {/* Celular */}
                        <input
                            type="tel"
                            placeholder="Seu celular"
                            className={estilo.contatoInput}
                            value={celular}
                            onInput={(e) => celularMascara(e)}
                            inputMode="numeric"
                        />

                        {/* Mensagem */}
                        <textarea
                            placeholder="Sua mensagem"
                            className={estilo.contatoInput}
                            value={mensagem}
                            onChange={(e) => setMensagem(e.target.value)}
                        />
                    </div>




                    <motion.button
                        whileHover={{ scale: 1.02, boxShadow: "0 0 10px 1px rgba(0,0,0,0.2)" }}
                        whileTap={{ scale: 0.95 }}
                        className={estilo.contatoBotao}
                        onClick={() => EmailPerfil()}
                    >
                        Enviar Mensagem
                    </motion.button>
                </motion.div>


            </section>

            <Footer />

        </>
    );
}
